import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import {
  api,
  formatApiError,
} from "@/lib/api";

const AuthContext =
  createContext(null);

const SESSION_REPLACED_MESSAGE =
  "Sua sessão foi encerrada porque esta conta foi acessada em outro dispositivo.";

export function AuthProvider({
  children,
}) {
  const [
    user,
    setUser,
  ] = useState(null);

  // null = carregando
  // false = visitante
  // objeto = usuário autenticado

  const [
    error,
    setError,
  ] = useState("");

  useEffect(() => {
    const interceptor =
      api.interceptors.response.use(
        (response) =>
          response,

        (requestError) => {
          const status =
            requestError.response
              ?.status;

          const detail =
            requestError.response
              ?.data?.detail;

          const url =
            requestError.config
              ?.url || "";

          const isLoginRequest =
            url.includes(
              "/auth/login"
            );

          const isMeRequest =
            url.includes(
              "/auth/me"
            );

          if (
            status === 401 &&
            !isLoginRequest &&
            !isMeRequest
          ) {
            localStorage.removeItem(
              "fc_token"
            );

            setUser(false);

            setError(
              formatApiError(detail) ||
                "Sua sessão expirou. Entre novamente."
            );
          }

          return Promise.reject(
            requestError
          );
        }
      );

    return () => {
      api.interceptors.response.eject(
        interceptor
      );
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } =
          await api.get(
            "/auth/me"
          );

        setUser(data);
      } catch (requestError) {
        const detail =
          requestError.response
            ?.data?.detail;

        localStorage.removeItem(
          "fc_token"
        );

        setUser(false);

        if (
          detail ===
          SESSION_REPLACED_MESSAGE
        ) {
          setError(detail);
        }
      }
    })();
  }, []);

  const login = async (
    identifier,
    password
  ) => {
    setError("");

    try {
      const { data } =
        await api.post(
          "/auth/login",
          {
            identifier:
              identifier.trim(),

            password,
          }
        );

      if (
        data.access_token
      ) {
        localStorage.setItem(
          "fc_token",
          data.access_token
        );
      }

      setUser(data);

      return true;
    } catch (requestError) {
      setError(
        formatApiError(
          requestError.response
            ?.data?.detail
        ) ||
          requestError.message
      );

      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post(
        "/auth/logout"
      );
    } catch {}

    localStorage.removeItem(
      "fc_token"
    );

    setUser(false);
    setError("");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        error,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () =>
  useContext(AuthContext);